import { redux } from '../../store';
import DrainPipeProvider from './drainPipeProvider';

export const getDrainPipeByIdAsync = DrainPipeProvider.getDrainPipeByIdAsync;

export const insertDrainPipeAsync = DrainPipeProvider.insertDrainPipeAsync;

export const updateDrainPipeAsync = DrainPipeProvider.updateDrainPipeAsync;

export const getPaginatedDrainPipePreviewsAsync = DrainPipeProvider.getPaginatedDrainPipePreviewsAsync;

export const getDrainPipeForCountryAsync = DrainPipeProvider.getDrainPipeForCountryAsync;
